/**
 * DOS518 - Digital Operations System for Wildfire Management
 * 
 * Copyright (c) 2024-2025 Angelo Irtilaç
 * All rights reserved.
 * 
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, modification, or use is strictly prohibited.
 * 
 * ---
 * 
 * Author: Angelo Irtilaç
 * Qualifications: DOS (Direttore delle Operazioni di Spegnimento)
 *                39 years - Corpo Nazionale dei Vigili del Fuoco
 *                DOS Trainer & Instructor
 * 
 * Location: Carpi, Italy
 * Contact: [inserire email]
 * 
 * ---
 * 
 * This software implements official Italian Fire Department protocols:
 * - C.O.A.U. (Centro Operativo Aereo Unificato)
 * - SI.TA.C. (Sistema Tattico di Coordinamento)
 * - L.A.C.E.S. (Lookout, Awareness, Communication, Escape routes, Safety zones)
 * 
 * Developed with operational expertise acquired through decades of wildfire
 * emergency management and coordination of suppression operations.
 * 
 * For commercial licensing inquiries, please contact the author.
 */
// src/main.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import CampoReporter from './components/Campo/CampoReporter';
import './index.css'; // Carica il CSS Master con i colori Arancio/Nero

/**
 * DOS518 - Entry Point
 * Questo file aggancia l'applicazione React al div con id "root" 
 * presente nel tuo index.html.
 */

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error("Elemento root non trovato. Controlla che il tuo index.html abbia <div id='root'></div>");
}

// Tablet di campo: ?campo=DOS-001  → mostra solo CampoReporter, niente App
const campoParam = new URLSearchParams(window.location.search).get('campo');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    {campoParam !== null
      ? <CampoReporter codiceParam={campoParam.toUpperCase()} />
      : <App />
    }
  </React.StrictMode>
);